const randomIndexOf = (array: Array<any>) => Math.floor(Math.random() * array.length)
const randomOf = (array: Array<any>) => array[randomIndexOf(array)]

export {randomIndexOf, randomOf}